import { Col, Row } from 'antd';
import { useTypeSafeTranslation } from 'hooks';
import { Trans } from 'next-i18next';
import { FC, useMemo } from 'react';
import { completed, inPipeline, inProgress } from '../datas';
import styles from './Header.module.less';

const Header: FC = () => {
  const { t } = useTypeSafeTranslation();

  const count = useMemo(() => {
    return [...inPipeline, ...inProgress, ...completed].reduce(
      (pre, next) => {
        const inprogress = Number(pre.inprogress) + Number(next.status === 'inprogress' ? 1 : 0);
        const inPipeline = Number(pre.inPipeline) + Number(next.status === 'in-pipeline' ? 1 : 0);
        const completed = Number(pre.completed) + Number(next.status === 'completed' ? 1 : 0);
        return {
          inprogress: inprogress,
          inPipeline: inPipeline,
          completed: completed,
        };
      },
      { inprogress: 0, inPipeline: 0, completed: 0 }
    );
  }, []);

  return (
    <>
      <div className={styles.bg}>
        <div className={styles.circle1} />
        <div className={styles.circle2} />
        <div className={styles.blurFooter} />
      </div>

      <div className={styles.root}>
        <div className={styles.headline}>
          <h1>{t('upcoming.title')}</h1>
          <p>
            <Trans i18nKey="upcoming.description" />
          </p>
        </div>

        <Row gutter={[0, 24]} justify="center" align="stretch">
          <Col xs={24} sm={8}>
            <div className={styles.card}>
              <img src="/images/upcoming/pipeline.svg" alt="in-progress" />
              <div>
                <h1 className={styles.accent}>{count.inPipeline}</h1>
                <p>{t('upcoming.in_pipeline_des')}</p>
              </div>
            </div>
          </Col>

          <Col xs={24} sm={8}>
            <div className={styles.card}>
              <img src="/images/upcoming/inprogress.svg" alt="in-progress" />
              <div>
                <h1 className={styles.orangeMain}>{count.inprogress}</h1>
                <p>{t('upcoming.inprogress_des')}</p>
              </div>
            </div>
          </Col>

          <Col xs={24} sm={8}>
            <div className={styles.card}>
              <img src="/images/upcoming/completed.svg" alt="in-progress" />
              <div>
                <h1 className={styles.success}>{count.completed}</h1>
                <p>{t('upcoming.completed_des')}</p>
              </div>
            </div>
          </Col>
        </Row>

        <p className={styles.content}>
          {/* Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque luctus, purus vitae lobortis imperdiet, est
          mauris semper nisi, ut convallis nulla enim vitae ex. Quisque ornare ornare finibus. Phasellus hendrerit
          libero eu quam maximus congue. Cras tempor auctor ante quis pellentesque. Nunc sed lacinia massa, sed
          tristique leo. Aliquam facilisis tincidunt dolor, in consectetur lorem lobortis a. Fusce at sapien vel ante
          convallis laoreet. Vestibulum tincidunt lectus sit amet mauris commodo consectetur. Vestibulum vehicula lorem
          nec imperdiet euismod. Cras feugiat convallis elit sed tincidunt. Praesent sed lacus a ligula fringilla
          sollicitudin vitae ut tortor. In blandit ac quam eu sodales. Duis id blandit sapien, sit amet finibus enim.
          Cras id tellus in metus consequat egestas a eget magna. Mauris feugiat at libero eget ullamcorper. */}
        </p>
      </div>
    </>
  );
};

export default Header;
